import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CourseCategories.css';

const CourseCategories = ({ title = 'Courses We Provide', items = [] }) => {
  const navigate = useNavigate();

  if (!items.length) return null;

  const handleClick = (item) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <section className="course-categories" aria-labelledby="course-categories-title">
      <div className="course-categories-inner">
        <header className="course-categories-header">
          <h2 id="course-categories-title" className="course-categories-title">
            {title}
          </h2>
          <div className="course-categories-underline" aria-hidden="true" />
        </header>
        <div className="course-categories-grid">
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              className="course-category-pill"
              onClick={() => handleClick(item)}
            >
              <span className="course-category-icon" aria-hidden="true">
                {item.icon || item.label.charAt(0)}
              </span>
              <span className="course-category-label">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CourseCategories;

